export default [
  // 账户删除
  {
    path: '/account-delete',
    component: () => import('@/views/accountDataDelete/accountDelete/Index.vue'),
    name: 'account-delete',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 账户删除
  {
    path: '/account-delete-validate',
    component: () => import('@/views/accountDataDelete/accountDelete/Validate.vue'),
    name: 'account-delete-validate',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 撤回
  {
    path: '/account-delete-applyBack',
    component: () => import('@/views/accountDataDelete/accountDelete/ApplyBack.vue'),
    name: 'account-delete-applyBack',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 结果
  {
    path: '/account-delete-result',
    component: () => import('@/views/accountDataDelete/accountDelete/Result.vue'),
    name: 'account-delete-result',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 选择数据
  {
    path: '/account-delete-selectData',
    component: () => import('@/views/accountDataDelete/accountDelete/SelectData.vue'),
    name: 'account-delete-selectData',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 选择数据
  {
    path: '/account-delete-submit',
    component: () => import('@/views/accountDataDelete/accountDelete/DeleteSubmit.vue'),
    name: 'account-delete-submit',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 网页
  {
    path: '/account-delete-webview',
    component: () => import('@/views/accountDataDelete/accountDelete/Webview.vue'),
    name: 'account-delete-webview',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
];
